export default __webpack_public_path__ + "static/media/State_Farm.96608a9f.svg";